import React from 'react';

const eur = (n) => `${(Number(n) || 0).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`;

const Kpi = ({ label, value, sub, color, testId }) => (
  <div className="bg-white rounded-xl border shadow-sm p-4">
    <p className="text-xs uppercase tracking-wide text-gray-500">{label}</p>
    <p className="text-2xl font-bold mt-1" style={color ? { color } : undefined} data-testid={testId}>{value}</p>
    {sub && <p className="text-xs text-gray-400 mt-0.5">{sub}</p>}
  </div>
);

const plural = (n, word) => `${n} ${word}${n === 1 ? '' : 's'}`;
const kpiSub = (t) => [
  `${t.count - t.with_invoice} sin factura`,
  t.pending ? `${plural(t.pending, 'pendiente')} de revisar` : null,
  t.duplicates ? `${t.duplicates} ${t.duplicates === 1 ? 'posible duplicado (no suma)' : 'posibles duplicados (no suman)'}` : null,
].filter(Boolean).join(' · ');

export const DetailKpis = ({ totals, color }) => (
  <div className="grid grid-cols-2 lg:grid-cols-4 gap-3" data-testid="expense-detail-kpis">
    <Kpi label="Total gastado" value={eur(totals.total)} color={color} sub={`${totals.count} gastos`} testId="expense-detail-total" />
    <Kpi label="Base imponible" value={eur(totals.base)} testId="expense-detail-base" />
    <Kpi label="IVA soportado" value={eur(totals.vat)} testId="expense-detail-vat" />
    <Kpi label="Con factura" value={`${totals.with_invoice} / ${totals.count}`}
      sub={kpiSub(totals)} testId="expense-detail-with-invoice" />
  </div>
);

export { eur };
